import { useState, useEffect, useMemo, useCallback } from "react";
import { useDispatch } from "react-redux";
// import { economicCalendarApi } from "../api/economicCalendarApi";
import { ImpactLevels } from "../ui/ImpactLevelSelect";
import { useEconomicCalendarData } from "@/redux/selectors/economicCalendar";
import {

    setEconomicCalendarSelectedCountry,
    setEconomicCalendarSelectedImpactLevel,
} from "@/redux/actions/economicCalendar";


// function extractCountries(data): {
//     icon: string;
//     label: string;
// }[] {
//     return Object.keys(data).map((key) => {
//         const { icon, label } = data[key][0];
//         if (label === 'EuroZone' || label === "Euro Zone") {
//             return { label: "Euro Zone", icon: "eu" };
//         }
//         if (label === "Hong Kong") {
//             return { label, icon: "hk" };
//         }
//         if (label === "Makedonia" || label === 'Macedonia') {
//             return { label, icon: "mkd" };
//         }
//         if (label === "Nambia" || label === "Namibia") {
//             return { label, icon: "nam" };
//         }

//         return {
//             icon,
//             label,
//         };
//     });
// }

export const useEconomicCalendar = () => {
    const dispatch = useDispatch();
    const [isLoading, setLoading] = useState(true);
    const { data, countries, selectedCountry, selectedImpactLevel } = useEconomicCalendarData();

    const fetchCalendarData = async () => {
        // TIP RANKS CALENDAR DATA HERE
        // try {
        //     const calendarData = await economicCalendarApi.getData();
        //     if (calendarData?.length) {
        //         const groupedByCountry = Object.groupBy(calendarData, ({ country }) => country);
        //         const countries = extractCountries(groupedByCountry);
        //         dispatch(setEconomicCalendarData(groupedByCountry));
        //         dispatch(setEconomicCalendarCountries(countries));
        //     } else {
        //         dispatch(setEconomicCalendarData({}));
        //     }
        // } catch (error) {
        //     console.error(error);
        // } finally {
        //     setLoading(false);
        // }
    };

    useEffect(() => {
        if (data !== null) {
            setLoading(false);
            return;
        }

        fetchCalendarData();
    }, []);

    const processedData = useMemo(() => {
        const dataByCountry = data?.[selectedCountry] || [];

        if (dataByCountry.length === 0) return [];

        const filteredData =
            selectedImpactLevel !== ImpactLevels.Any
                ? dataByCountry.filter(({ impact }) => impact === selectedImpactLevel)
                : dataByCountry;

        return filteredData.toSorted((a, b) => {
            const timeA = a.time ? new Date(a.time).getTime() : 0;
            const timeB = b.time ? new Date(b.time).getTime() : 0;
            return timeA - timeB;
        });
    }, [data, selectedCountry, selectedImpactLevel]);

    const setImpactLevel = useCallback(
        (impactLevel: ImpactLevels) => {
            dispatch(setEconomicCalendarSelectedImpactLevel(impactLevel));
        },
        [dispatch]
    );

    const setCountry = useCallback(
        (country: string) => {
            if (selectedImpactLevel !== ImpactLevels.Any) {
                dispatch(setEconomicCalendarSelectedImpactLevel(ImpactLevels.Any));
            }
            dispatch(setEconomicCalendarSelectedCountry(country));
        },
        [selectedImpactLevel, dispatch]
    );

    return {
        data: processedData,
        selectedImpactLevel,
        selectedCountry,
        countries,
        isLoading,
        setImpactLevel,
        setCountry,
        refetch: fetchCalendarData,
    };
};
